module.exports = __webpack_public_path__ + "img/17-2.ea467c15.jpg";